module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0006.1b8d1490.jpg";